import { 
  COLOR_WARM_GREY,
  SliceBannerTout,
  SliceBannerToutProps,
  SliceBlurbImage,
  SliceContentBlockLinks,
  SliceContentImage,
  SliceImageBlocks,
  SliceIntro,
  SliceIntroProps,
  SlicePersonBioGrid,
  SlicePersonBioGridProps,
  createSliceLayout,
} from '@shapeable/ui';
// import { SliceBannerTout, SliceBannerToutProps } from '../entities/slice-banner-tout';
import { SliceProductBenefits } from '../entities/slice-product-benefit';
import { SliceProductIndustries } from '../entities/slice-product-industries';
import { YELLOW } from '../../theme';
import { ProductGrid } from '../entities/product-grid';

// Augment standard site layouts here by exporting additional or replacement layouts.
// (simply use the same key to replace any existing slice layouts).

export const SliceLayoutProductGrid = createSliceLayout(
  ProductGrid, {
    verticalPadding: 'small',
    boundary: 'content-bleed',
    
  },
);

export const SliceLayoutPeople = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    verticalPadding: 'small',
    props: {
      transform: '',
    }
  }
);

export const SliceLayoutBannerTout = createSliceLayout<SliceBannerToutProps>(
  SliceBannerTout, {
    verticalPadding: 'large',
    props: {
      
    }
  }
);

export const SliceLayoutBenefits = createSliceLayout(
  SliceProductBenefits, {
    verticalPadding: 'large',
  }
);

export const SliceLayoutProductIndustries = createSliceLayout(
  SliceProductIndustries  , {
    verticalPadding: 'small',
    boundary: 'content',
    defaultBackgroundColor: COLOR_WARM_GREY,
  }
);

export const SliceLayoutKeyPillars = createSliceLayout(
  SliceImageBlocks, {
    verticalPadding: 'small',
    props: {
      desktopAutoColumns: 4,
      desktopLargeAutoColumns: 4,
    }
  }
);

export const SliceLayoutContentBlockLinks = createSliceLayout(
  SliceContentBlockLinks, {
    verticalPadding: 'medium',
    props: {
      hoverColor: YELLOW,
    }
  }
);

export const SliceLayoutIntro = createSliceLayout(
  SliceIntro, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutContentImage = createSliceLayout(
  SliceContentImage, {
    verticalPadding: 'none',
  }
);